import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import 'bootstrap/dist/css/bootstrap.min.css';

const startApp = () => {
    ReactDOM.render(<App />, document.getElementById('root'));
    serviceWorker.register();
  };
  
if(window.cordova) {
  document.addEventListener('deviceready', startApp, false);
} else {
  startApp();
}
